var dispatcher = require("enyo/dispatcher"),
    kind       = require("enyo/kind");

/**
 * [DropdownCaptureSupport]{@link app.ui.DropdownCaptureSupport} allows a
 * [Dropdown]{@link enyo-ui.Dropdown} to capture taps outside it's bounds and close
 * itself accordingly.
 *
 * @mixin app.ui.DropdownCaptureSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "app.ui.DropdownCaptureSupport",

    /**
     * @type     {boolean}
     * @default  false
     * @memberof app.ui.DropdownCaptureSupport
     * @public
     */
    isCapturing: false,

    /**
     * @name     propagateCapturedTap
     * @type     {boolean}
     * @default  false
     * @memberof app.ui.DropdownCaptureSupport
     * @public
     */

    /**
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            // By default, we don't propagate captured tap events
            if (this.propagateCapturedTap === undefined) {
                this.propagateCapturedTap = false;
            }
            this.$.dropdown.observe("absoluteShowing", this.dropdownVisibilityChanged, this);
        };
    }),

    /**
     * If the popup just became `absoluteShowing` and isn't yet capturing tap
     * events, we should start doing so now so the popup can be closed again by
     * tapping outside it.
     *
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @private
     */
    dropdownVisibilityChanged: kind.inherit(function(sup) {
        return function(wasShowing) {
            var isShowing = this.$.dropdown.absoluteShowing;

            sup.apply(this, arguments);

            if (isShowing && !wasShowing) {
                this.startCapturing();
            }
            else if (wasShowing && !isShowing) {
                this.stopCapturing();
            }
        };
    }),

    // Closing behavior
    // --------------------------------

    /**
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @private
     */
    startCapturing: function() {
        if (!this.isCapturing) {
            dispatcher.capture(this, {
                ontap: "maybeCloseOnCapturedTap"
            });
            this.isCapturing = true;
        }
    },

    /**
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @private
     */
    stopCapturing: function() {
        if (this.isCapturing) {
            dispatcher.release(this);
            this.isCapturing = false;
        }
    },

    /**
     * Close the popup when tapping outside of it.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Event}         event   The event
     * @returns  {boolean}       Stop propagation of the tap
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @protected
     */
    maybeCloseOnCapturedTap: function(sender, event) {
        var tapContainerPath = this.get("tapContainerPath") || null,
            tapContainer     = tapContainerPath ? this.get(tapContainerPath) : this,
            tapContainerNode = tapContainer.hasNode();

        if (tapContainerNode && !tapContainerNode.contains(event.target)) {
            this.hideDropdown();

            return !this.propagateCapturedTap;
        }

        return false;
    },

    /**
     * Stop capturing on destroy
     *
     * @memberof app.ui.DropdownCaptureSupport
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.stopCapturing();
            sup.apply(this, arguments);
        };
    })

};
